import { GetServerSideProps, NextPage } from 'next'
import { PageForgotPassword } from 'src/components/pages'
import { getSubdomainFromHost } from 'src/fixtures/utils/url'

type InitialProps = {
  subdomain?: string
}

type Props = {} & InitialProps

const Index: NextPage<Props> = ({ subdomain }: Props) => {
  return <PageForgotPassword subdomain={subdomain} />
}

export default Index

export const getServerSideProps: GetServerSideProps = async ctx => {
  const host = ctx.req.headers.host
  const subdomain = getSubdomainFromHost(host)
  return { props: { subdomain: subdomain ?? null } }
}
